'use client'

import type { GradeShareData } from '../lib/types'
import { Avatar } from './Avatar'
import styles from './StickyCta.module.css'

/**
 * Sticky CTA bar pinned to the bottom of the viewport (full-bleed, mobile +
 * desktop). Mobile: header + attribution row over a full-width button.
 * Desktop: a single horizontal bar — messaging left, compact button right.
 * Opens the WIP dialog until the app/referral funnel is wired.
 */
export function StickyCta({
  user,
  onGetApp,
}: {
  user: GradeShareData['user']
  onGetApp: () => void
}) {
  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.info}>
          <span className={styles.header}>Get a free AI grade</span>
          <span className={styles.attribution}>
            Shared by
            <Avatar
              pokemonId={user.pokemonId}
              profileColor={user.profileColor}
              username={user.username}
              size={18}
            />
            <span className={styles.attrName}>{user.username}</span>
          </span>
        </div>
        <button className={styles.button} onClick={onGetApp}>
          Get the app
        </button>
      </div>
    </div>
  )
}
